import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import * as _ from 'lodash';

import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'string-list-editor',
  templateUrl: './string-list-editor.component.html',
  styleUrls: ['./string-list-editor.component.css'],
})
export class StringListEditorComponent implements OnInit {
  @Input() texteAjouter: string = 'Ajouter';
  @Input() texteAucun: string = 'Aucun enregistrement trouvé';
  @Input() texteNombreDe: string = 'Nombre';
  @Input() texteNomColonne: string = 'Nom';
  @Input() displayFiltre: boolean = true;
  @Input() readonly: boolean = false;
  @Input() rows: number = 25;
  @Input() paginator: boolean = true;
  @Input() maxlength: number = 1024;
  @Input() form: NgForm;

  // To detect input change
  private _values: string[] = [];
  @Input()
  set values(values: string[]) {
    this._values = values;
    this.valuesInternal = _.map(this._values, v => <Edit<string>>{ item: v, editing: false, clone: null });
  }
  get values(): string[] {
    return this._values;
  }
  valuesInternal: Edit<string>[];
  @Output() valuesChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  constructor(
    public dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {}

  // Edit
  addValue() {
    this.valuesInternal.push(<Edit<string>>{ editing: true });
  }

  edit(composant: Edit<string>) {
    composant.clone = composant.item;
    composant.editing = true;
  }

  save(index: number, event: any) {
    event?.stopPropagation();
    if (this._values[index]) {
      let composant = this.valuesInternal[index];
      composant.item = this.values[index];
      composant.clone = null;
      composant.editing = false;
      this.updateValues();
    } else {
      this.notificationService.error('Le champ est obligatoire');
    }
  }

  delete(index: number) {
    this.confirmationService.confirm({
      message: 'Confirmer-vous la suppression ?',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.valuesInternal.splice(index, 1);
        this.values.splice(index, 1);
      },
    });
  }

  private updateValues() {
    this._values = _.map(this.valuesInternal, v => v.item);
    this.valuesChange.emit(this._values);
  }

  cancel(index: number) {
    let editValue = this.valuesInternal[index];
    if (editValue.clone) {
      editValue.item = editValue.clone;
      this._values[index] = editValue.clone;
      editValue.clone = null;
      editValue.editing = false;
    } else {
      this.valuesInternal.splice(index, 1);
      this.values.splice(index, 1);
    }
    this.updateValues();
  }
}

export interface Edit<T> {
  item: T;
  editing: boolean;
  clone: T;
}
